/**
 * Returns icon emoji and translation key for a given media type.
 * Used to display user-friendly media type labels in reply previews.
 * 
 * @param {string} mediaType - Type of media (audio, video, image, document, location)
 * @returns {Object} { icon, translationKey } - Icon emoji and i18n translation key
 * 
 * @example
 * getMediaTypeDisplay('image') // Returns: { icon: '📷', translationKey: 'photo' }
 * getMediaTypeDisplay('unknown') // Returns: { icon: '📎', translationKey: 'attachment' }
 */
export const getMediaTypeDisplay = (mediaType) => {
    const mediaTypeMap = {
        image: { icon: '📷', translationKey: 'photo' },
        video: { icon: '🎥', translationKey: 'video' },
        audio: { icon: '🎵', translationKey: 'audio' },
        document: { icon: '📄', translationKey: 'document' },
        location: { icon: '📍', translationKey: 'location' }
    };

    return mediaTypeMap[mediaType] || { icon: '📎', translationKey: 'attachment' };
};
